// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"517":"9e266f8a","592":"2a13c2bc"}[chunkId] + ".chunk.js";
};